import { render, staticRenderFns } from "./IPKoenenTest.vue?vue&type=template&id=23007eaa&"
import script from "./IPKoenenTest.vue?vue&type=script&lang=js&"
export * from "./IPKoenenTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports